const appVersion = process.env.REACT_APP_VERSION || "0.1.0";

export default appVersion;